import styled from 'styled-components';
import Button from '../Button';
import Icon from '../Icon';

export const Wrapper = styled.div`
  position: relative;
`;

export const CloseButton = styled(Button)`
  background: transparent;
  border-radius: 0;
  border: none;
  color: #9c9c9c;
  height: 20px;
  margin: 0;
  padding: 0;
  position: absolute;
  right: 32px;
  text-shadow: none;
  top: 32px;
  width: 20px;
  z-index: 10;

  &:active,
  &:hover {
    background: transparent !important;
    color: #767676 !important;
    text-shadow: none !important;
  }

  &:focus {
    background: transparent !important;
    color: #767676 !important;
    text-shadow: none !important;
  }
`;

export const CloseIcon = styled(Icon)`
  font-size: 20px;
  vertical-align: top;
  color: inherit;
  transition: color 0.3s ease;
`;
